import "../landingPage/Landing.css";

function LandingFooter() {
  return <div className="landing-footer">
    <span>&copy; All rights reserved</span>
  </div>;
}

export default LandingFooter;
